import type { ClinicRow, HealthState } from '@pa/api/admin'
import { heartbeatText, isAwaitingCode, useNow } from '@pa/staff'

/** S-02's words for a component state (UserFlows S-02: healthy / degraded / down). */
export const HEALTH_WORD: Record<HealthState, string> = {
  up: 'healthy',
  degraded: 'degraded',
  down: 'down',
  unknown: 'no data',
}

const DOT: Record<HealthState, string> = { up: 'sd-ok', degraded: 'sd-warn', down: 'sd-down', unknown: 'sd-idle' }

/**
 * The S-02 Health column (UserFlows S-02; API.md §3.8 `ClinicRow.pf`): PF Keeper and PF session as healthy /
 * degraded / down, with the last heartbeat (counting up locally, Observability §5.6). Not-connected and inactive
 * clinics have no health.
 */
export function HealthCell({ pf }: { pf: ClinicRow['pf'] }) {
  const now = useNow()
  if (pf.status === 'not_connected' || pf.status === 'inactive') {
    return <span className="muted">—</span>
  }
  // Task 25: amber "PF waiting for a security code" instead of the session's state.
  const awaiting = isAwaitingCode(pf)
  return (
    <div className="health-cell">
      <span className="hc-line">
        <span className={`state-dot ${DOT[pf.pfKeeperApp]}`} aria-hidden />
        PF Keeper {HEALTH_WORD[pf.pfKeeperApp]}
      </span>
      <span className="hc-line">
        <span className={`state-dot ${awaiting ? 'sd-warn' : DOT[pf.pfSession]}`} aria-hidden />
        {awaiting ? 'PF waiting for a security code' : `PF session ${HEALTH_WORD[pf.pfSession]}`}
      </span>
      <span className="cell-sub">{heartbeatText(pf.lastHeartbeatAt, now)}</span>
    </div>
  )
}
